// extracted by mini-css-extract-plugin
var _1 = "VaueqINm_gU_HPuJcvvM";
var _2 = "pZ_UkYGBuPG07TOh4x2v";
var _3 = "VKF__owV7RVsYf3SyipJ";
var _4 = "QABiXh1HFEWxKbGsv2tD";
export { _1 as "menuItem", _2 as "menuItemDescription", _3 as "menuWrapper", _4 as "toggleButton" }
